import { Link, withStyles } from "@material-ui/core";
import React from "react";
import { compose } from "recompose";
import { withAppConfig } from "../../../../../../appConfigContext";
import { withFeatureFlags } from "../../../../../../userProfile/featureFlagsContext";
import IFrameRenderer from "../../../../../common/IFrameRenderer";
import appConstants from "@appConstants";

const getImagesWebURL = ({ proNumber, proMinLengthForImage, proImagesUrl }) => {
  const updatedProNumber = proMinLengthForImage
    ? proNumber.padStart(proMinLengthForImage, 0)
    : proNumber;
  let imagesWebUrl = proImagesUrl;
  if (imagesWebUrl) {
    imagesWebUrl = imagesWebUrl.replace("${0}", updatedProNumber);
  }
  return imagesWebUrl;
};

const styles = (theme) => ({
  label: {
    color: theme.gridTextColor,
    textTransform: "capitalize",
    margin: "12px 0",
  },
  imageContainer: {
    width: "100%",
    minHeight: "40vh",
  },
});

const IBPlanningProImages = ({proNumber, configJSON, featureFlags, classes }) => {
  if(!configJSON.proImagesUrl){
   return null;
  }
  
  const showProImagesPopup = featureFlags.isFeatureEnabled(
    appConstants.features.ShowProImagesInPopup
  );

  const url = getImagesWebURL({
    proNumber,
    proMinLengthForImage: configJSON.proMinLengthForImage,
    proImagesUrl: configJSON.proImagesUrl,
  });

  return (
    <>
      <div className={classes.label}>Other Images</div>
      {showProImagesPopup ? (
        <div className={classes.imageContainer}>
          <IFrameRenderer url={url} />
        </div>
      ) : (
        <div>
          <Link
            color="primary"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Pro Images in new tab
          </Link>
        </div>
      )}
    </>
  );
};

export default compose(
  withFeatureFlags,
  withAppConfig,
  withStyles(styles)
)(IBPlanningProImages);
